import { formatDistance } from 'date-fns';

export const twoDigitString = (number: number) => {
    return `${number}`.slice(-2);
};

export const getDurationString = (minutes: number) => {
    const minute = twoDigitString(minutes % 60);
    if (minutes === 0) {
        return `12am`;
    }
    if (minutes >= 720 && minutes < 780) {
        return `12${minute === '0' ? '' : `:${minute}`}pm`;
    }
    const hour = twoDigitString(minutes / 60 === 12 ? 12 : Math.floor((minutes / 60) % 12));
    let ampm = '';
    if (minutes / 60 === 12 || Math.floor(minutes / 60) < 12) {
        ampm = 'am';
    } else {
        ampm = 'pm';
    }
    return `${hour}${minute === '0' ? '' : `:${minute}`}${ampm}`;
};

export const getRelativeTime = (date: Date | number) => {
    if (!date) {
        return '';
    } else {
        return formatDistance(new Date(date), new Date(), { addSuffix: true });
    }
};
